<template>
  <el-table @row-dblclick="dbclick"
            @row-click="handleRowClick"
            @sort-change="sortChange"
            @selection-change="handleSelectionChange"
            id="table"
            ref="table"
            :row-class-name="tableRowClassName"
            :cell-class-name="tableCellClassName"
            :show-summary="showSummary"
            :summary-method="getsummaries"
            :header-cell-class-name="cellClass"
            :header-cell-style="tableHeaderCellStyle"
            :data="tableData"
            :style="width"
            :height="height || 600"
            border
            stripe
            highlight-current-row
            :default-sort="{ order: 'descending' }">
    <template slot="empty">
      <p class="emptyText"
         v-if="!tableEmptyText">{{ EmptyText }}</p>
      <p v-else
         style="text-decoration: underline; cursor: pointer; color: #409eff"
         @click="EmptyBtn">
        {{ tableEmptyText }}
      </p>
    </template>

    <el-table-column v-if="tableType"
                     :type="tableType"
                     align="center"
                     width="55"
                     :selectable="isRowCanBeSelect">
    </el-table-column>
    <!-- 设置序号 -->
    <el-table-column align="center"
                     width="60"
                     v-if="indexFlag"
                     label="序号">
      <template slot-scope="scope">
        <slot name="index"
              :scope="scope"></slot>
      </template>
    </el-table-column>

    <template v-for="(item, i) in tableConfig">
      <!-- 二级复合表头 -->
      <el-table-column :key="i"
                       v-if="item.children && item.flag"
                       :label="item.label"
                       :show-overflow-tooltip="true"
                       header-align="center">
        <template v-for="child in item.children">
          <el-table-column v-if="!child.slotName  && child.flag"
                           :key="child.field"
                           :sortable="child.sortable"
                           :prop="child.field"
                           :width="child.width"
                           :min-width="child.minWidth"
                           :label="child.label"
                           :align="child.align"
                           :fixed="child.fixed"
                           header-align="center"
                           :show-overflow-tooltip="true">
            <template slot-scope="scope">
              <el-popover v-if="child.showPopover"
                          placement="top"
                          popper-class="explan-popper"
                          :show-overflow-tooltip="true">
                {{ scope.row[child.field] }}
                <span v-if="!child.method">{{ scope.row[child.field] }}</span>
                <span slot="reference"
                      v-if="!child.child">{{
                  scope.row[child.field]
                }}</span>
                <span slot="reference"
                      class="pointer"
                      style="text-decoration: underline"
                      v-else
                      @click="
                    () => {
                      $emit(child.method, scope.row);
                    }
                  ">{{ scope.row[child.field] }}</span>
              </el-popover>
              <template v-else>
                <el-input @change="inputChange($event, child.field, scope.row)"
                          size="mini"
                          :ref="scope.row.index + ',' + scope.column.index"
                          v-model="scope.row[child.field]"
                          v-if="
                    scope.row.index + ',' + scope.column.index == currentCell &&
                    child.style == 1
                  ">
                </el-input>
                <el-select size="mini"
                           @change="
                    selectChange(
                      $event,
                      child.list,
                      child.field,
                      scope.row,
                      false
                    )
                  "
                           filterable
                           v-model="scope.row[child.field]"
                           style="width: 100%"
                           placeholder="请选择"
                           v-else-if="
                    scope.row.index + ',' + scope.column.index == currentCell &&
                    child.style == 2
                  ">
                  <el-option v-for="i in child.list"
                             :key="i.id"
                             :label="i.customerName"
                             :value="i.customerName">
                  </el-option>
                </el-select>

                <el-date-picker size="mini"
                                v-else-if="
                    scope.row.index + ',' + scope.column.index == currentCell &&
                    child.style == 3
                  "
                                v-model="scope.row[child.field]"
                                type="date"
                                placeholder="选择日期"
                                value-format="yyyy-MM-dd"
                                @change="selectDate($event, child.field, scope.row)">
                </el-date-picker>

                <span v-else
                      :style="{ textAlign: child.align }">
                  {{ scope.row[child.field] }}
                </span>
              </template>
            </template>
          </el-table-column>
        </template>
        <template v-for="child in item.children">
          <el-table-column :key="child.field"
                           v-if="child.slotName && child.flag"
                           :sortable="child.sortable"
                           :prop="child.field"
                           :min-width="child.minWidth"
                           :width="child.width"
                           :label="child.label"
                           :align="child.align"
                           :show-overflow-tooltip="true"
                           :fixed="child.fixed"
                           header-align="center">
            <template slot-scope="scope">
              <el-input @change="inputChange($event, child.field, scope.row)"
                        size="mini"
                        :ref="scope.row.index + ',' + scope.column.index"
                        v-model="scope.row[child.field]"
                        v-if="
                  scope.row.index + ',' + scope.column.index == currentCell &&
                  child.style == 1
                ">
              </el-input>
              <el-select @change="
                  selectChange($event, child.list, child.field, scope.row, true)
                "
                         filterable
                         size="mini"
                         v-model="scope.row[child.field]"
                         style="width: 100%"
                         placeholder="请选择"
                         v-else-if="
                  scope.row.index + ',' + scope.column.index == currentCell &&
                  child.style == 2
                ">
                <el-option v-for="i in child.list"
                           :key="i.value"
                           :label="i.text"
                           :value="i.value"></el-option>
              </el-select>

              <el-date-picker @change="selectDate($event, child.field, scope.row)"
                              class="date-picker"
                              size="mini"
                              v-else-if="
                  scope.row.index + ',' + scope.column.index == currentCell &&
                  child.style == 3
                "
                              v-model="scope.row[child.field]"
                              type="date"
                              placeholder="选择日期"
                              value-format="yyyy-MM-dd">
              </el-date-picker>

              <slot v-else
                    :name="child.slotName"
                    :scope="scope"></slot>
            </template>
          </el-table-column>
        </template>
      </el-table-column>

      <!-- 一级 -->
      <el-table-column :key="i"
                       v-if="item.slotName  && item.flag && !item.children"
                       :sortable="item.sortable"
                       :prop="item.field"
                       :min-width="item.minWidth"
                       :width="item.width"
                       :label="item.label"
                       :align="item.align"
                       :show-overflow-tooltip="true"
                       :fixed="item.fixed"
                       header-align="center">
        <template slot-scope="scope">
          <el-input @change="inputChange($event, item.field, scope.row)"
                    size="mini"
                    :ref="scope.row.index + ',' + scope.column.index"
                    v-model="scope.row[item.field]"
                    v-if="
              scope.row.index + ',' + scope.column.index == currentCell &&
              item.style == 1
            ">
          </el-input>
          <el-select @change="
              selectChange($event, item.list, item.field, scope.row, true)
            "
                     filterable
                     size="mini"
                     v-model="scope.row[item.field]"
                     style="width: 100%"
                     placeholder="请选择"
                     v-else-if="
              scope.row.index + ',' + scope.column.index == currentCell &&
              item.style == 2
            ">
            <el-option v-for="i in item.list"
                       :key="i.value"
                       :label="i.text"
                       :value="i.value"></el-option>
          </el-select>

          <el-date-picker @change="selectDate($event, item.field, scope.row)"
                          class="date-picker"
                          size="mini"
                          v-else-if="
              scope.row.index + ',' + scope.column.index == currentCell &&
              item.style == 3
            "
                          v-model="scope.row[item.field]"
                          type="date"
                          placeholder="选择日期"
                          value-format="yyyy-MM-dd">
          </el-date-picker>

          <slot v-else
                :name="item.slotName"
                :scope="scope"></slot>
        </template>
      </el-table-column>

      <el-table-column v-if="!item.slotName && item.flag  && !item.children"
                       :key="`${i}`"
                       :sortable="item.sortable"
                       :prop="item.field"
                       :width="item.width"
                       :min-width="item.minWidth"
                       :label="item.label"
                       :align="item.align"
                       :fixed="item.fixed"
                       header-align="center"
                       :show-overflow-tooltip="true">
        <template slot-scope="scope">
          <el-popover v-if="item.showPopover"
                      placement="top"
                      popper-class="explan-popper"
                      :show-overflow-tooltip="true">
            {{ scope.row[item.field] }}
            <span v-if="!item.method">{{ scope.row[item.field] }}</span>
            <span slot="reference"
                  v-if="!item.method">{{
              scope.row[item.field]
            }}</span>
            <span slot="reference"
                  class="pointer"
                  style="text-decoration: underline"
                  v-else
                  @click="
                () => {
                  $emit(item.method, scope.row);
                }
              ">{{ scope.row[item.field] }}</span>
          </el-popover>
          <template v-else>
            <el-input @change="inputChange($event, item.field, scope.row)"
                      size="mini"
                      :ref="scope.row.index + ',' + scope.column.index"
                      v-model="scope.row[item.field]"
                      v-if="
                scope.row.index + ',' + scope.column.index == currentCell &&
                item.style == 1
              ">
            </el-input>
            <el-select size="mini"
                       @change="
                selectChange($event, item.list, item.field, scope.row, false)
              "
                       filterable
                       v-model="scope.row[item.field]"
                       style="width: 100%"
                       placeholder="请选择"
                       v-else-if="
                scope.row.index + ',' + scope.column.index == currentCell &&
                item.style == 2
              ">
              <el-option v-for="i in item.list"
                         :key="i.value ? i.value : i.id"
                         :label="i.text ? i.text : i.customerName"
                         :value="i.value ? i.value : i.customerName"></el-option>
            </el-select>

            <el-date-picker size="mini"
                            v-else-if="
                scope.row.index + ',' + scope.column.index == currentCell &&
                item.style == 3
              "
                            v-model="scope.row[item.field]"
                            type="date"
                            placeholder="选择日期"
                            value-format="yyyy-MM-dd"
                            @change="selectDate($event, item.field, scope.row)">
            </el-date-picker>

            <span v-else
                  :style="{ textAlign: item.align }">
              {{ scope.row[item.field] }}
            </span>
          </template>
        </template>
      </el-table-column>
    </template>
  </el-table>
</template>

<script>
export default {
  props: {
    tableEmptyText: String,
    EmptyText: {
      type: String,
      default: "暂无数据",
    },
    promoter: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    //是否设置行号
    indexFlag: {
      default: false,
      type: Boolean,
    },
    //是否设置单选
    radioFlag: {
      default: false,
      type: Boolean,
    },
    // 恢复：是否开启行点击勾选效果（核心控制）
    rowClickFlag: {
      default: false,
      type: Boolean,
    },
    //是否需要全选按钮
    DisableSelection: {
      default: false,
      type: Boolean,
    },
    //是否显示总计
    showSummary: {
      default: false,
      type: Boolean,
    },
    //合计行的规则
    totalRule: {
      type: Array,
    },
    width: {
      default: "width: 100%",
      type: String,
    },
    height: String,
    tableType: String,
    tableConfig: Array,
    tableData: Array,
    // 行唯一标识字段
    rowKey: {
      type: String,
      default: "id"
    },
    // 禁止选中的行判断条件（支持函数/数组）
    disabledRowKeys: {
      type: [Function, Array],
      default: () => false
    }
  },
  data () {
    return {
      currentCell: null,
      inded: "",
      // 维护选中行的唯一标识
      selectedRowKeys: [],
      multipleSelection: [],
      rowClickTimer: null,
    };
  },
  updated () {
    this.$nextTick(() => {
      this.$refs["table"]?.doLayout();
    });
  },
  methods: {
    // ========== 核心：判断行是否可选中 ==========
    isRowCanBeSelect (row) {
      // 1. 原有promoter相关的禁止逻辑保留
      if (this.promoter) {
        if (
          row.isCanMultipleAccessRemit === false ||
          row.userIsNotarize === false ||
          row.applyStatus == "已入职" ||
          row.applyStatus == "已离职(非自离)" ||
          row.applyStatus == "面试未通过" ||
          row.applyStatus == "已取消" ||
          row.carType == "8"
        ) {
          return false;
        }
      }

      // 2. 根据disabledRowKeys判断是否禁止选中
      const rowKeyValue = row[this.rowKey];
      if (typeof this.disabledRowKeys === 'function') {
        if (this.disabledRowKeys(row)) {
          return false;
        }
      } else if (Array.isArray(this.disabledRowKeys)) {
        if (this.disabledRowKeys.includes(rowKeyValue)) {
          return false;
        }
      }

      return true;
    },

    // ========== 手动判断行是否选中（兼容低版本） ==========
    isRowSelected (row) {
      if (!row) return false;
      const rowKeyValue = row[this.rowKey];
      return this.selectedRowKeys.includes(rowKeyValue);
    },

    // ========== 清空选中状态 ==========
    clearSelection () {
      if (this.$refs.table) {
        this.tableData.forEach(row => {
          this.$refs.table.toggleRowSelection(row, false);
        });
      }
      this.selectedRowKeys = [];
      this.multipleSelection = [];
      this.$emit("selectionChange", []);
    },

    // ========== 切换行选中状态（核心方法） ==========
    toggleRowSelection (row, selected) {
      // 先判断行是否可选中
      if (!this.isRowCanBeSelect(row)) return;

      if (!row || !this.$refs.table) return;
      const rowKeyValue = row[this.rowKey];

      // 确定最终选中状态
      const finalSelected = typeof selected === 'boolean'
        ? selected
        : !this.isRowSelected(row);

      // 切换表格选中状态
      this.$refs.table.toggleRowSelection(row, finalSelected);

      // 更新本地选中数据
      if (finalSelected) {
        if (!this.selectedRowKeys.includes(rowKeyValue)) {
          this.selectedRowKeys.push(rowKeyValue);
          this.multipleSelection.push(row);
        }
      } else {
        this.selectedRowKeys = this.selectedRowKeys.filter(key => key !== rowKeyValue);
        this.multipleSelection = this.multipleSelection.filter(item => item[this.rowKey] !== rowKeyValue);
      }

      // 触发父组件事件
      this.$emit("selectionChange", this.radioFlag ? this.multipleSelection[0] || {} : this.multipleSelection);
    },

    // ========== 全选/取消全选（自动跳过禁止行） ==========
    toggleAllSelection () {
      if (this.radioFlag || !this.$refs.table) return;

      const isAllSelected = this.selectedRowKeys.length === this.tableData.filter(row => this.isRowCanBeSelect(row)).length;
      if (isAllSelected) {
        this.clearSelection();
      } else {
        this.tableData.forEach(row => {
          if (this.isRowCanBeSelect(row)) {
            const rowKeyValue = row[this.rowKey];
            if (!this.selectedRowKeys.includes(rowKeyValue)) {
              this.$refs.table.toggleRowSelection(row, true);
              this.selectedRowKeys.push(rowKeyValue);
              this.multipleSelection.push(row);
            }
          }
        });
        this.$emit("selectionChange", this.multipleSelection);
      }
    },

    // ========== 处理选择框变化 ==========
    handleSelectionChange (selection) {
      // 过滤掉禁止选中的行
      const validSelection = selection.filter(row => this.isRowCanBeSelect(row));
      this.multipleSelection = validSelection;
      this.selectedRowKeys = validSelection.map(row => row[this.rowKey]);

      // 单选模式：只保留最后一个选中项
      if (this.radioFlag && validSelection.length > 1) {
        const lastRow = validSelection[validSelection.length - 1];
        this.clearSelection();
        this.$refs.table.toggleRowSelection(lastRow, true);
        this.selectedRowKeys = [lastRow[this.rowKey]];
        this.multipleSelection = [lastRow];
      }

      this.$emit("selectionChange", this.radioFlag ? (this.multipleSelection[0] || {}) : validSelection);
    },

    // ========== 核心：单击行逻辑（恢复rowClickFlag控制） ==========
    handleRowClick (row, column, ev) {
      ev.stopPropagation();
      ev.preventDefault();

      // 防抖处理
      if (this.rowClickTimer) clearTimeout(this.rowClickTimer);
      this.rowClickTimer = setTimeout(() => {
        // 清空单元格编辑状态
        if (this.inded !== row.index) {
          this.currentCell = null;
        }
        this.inded = row.index;

        // 核心控制：仅当rowClickFlag为true + tableType为selection + 行可选中时，才触发勾选逻辑
        if (this.rowClickFlag && this.tableType === "selection" && this.isRowCanBeSelect(row)) {
          if (this.radioFlag) {
            // 单选模式：如果点击的是已选中行，取消选中；否则清空后选中
            const isSelected = this.isRowSelected(row);
            if (isSelected) {
              this.clearSelection();
            } else {
              this.clearSelection();
              this.toggleRowSelection(row, true);
            }
          } else {
            // 多选模式：直接切换选中/取消状态
            this.toggleRowSelection(row);
          }
        }

        // 触发行点击事件（透传，无论是否勾选都触发）
        this.$emit("rowClick", row);
      }, 50);
    },

    // ========== 原有方法保留 ==========
    EmptyBtn () {
      this.$emit("EmptyBtn");
    },
    getsummaries (param) {
      const { columns, data } = param;
      const sums = [];
      const nums = [];
      let totalRule = this.totalRule;
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = (
            <div class="countClass">
              <p class="count_row">
                小计 <br />
                <br />
                总计{" "}
              </p>{" "}
            </div>
          );
          return;
        }
        const values = data.map((item) => Number(item[column.property]));
        if (!values.every((value) => isNaN(value))) {
          nums[index] = values.reduce((prev, curr) => {
            const value = Number(curr);
            return !isNaN(value) ? prev + curr : prev;
          }, 0);
        }
        if (totalRule[index]) {
          sums[index] = (
            <div class="countClass">
              <p class="count_row">
                {totalRule[index].nums ? nums[index] : ""} <br />
                <br />
                {totalRule[index].total ? totalRule[index].totalNum : ""}
              </p>
            </div>
          );
        } else {
          sums[index] = (
            <div class="countClass">
              <p class="count_row">
                <br />
                <br />
              </p>
            </div>
          );
        }
      });
      return sums;
    },
    tableHeaderCellStyle (row) {
      return row.column.property === "shouldSalary" || row.column.property === "netPayroll"
        ? "color: red; font-size:15px; font-weight:520;"
        : "color: black; font-size:15px; font-weight:520;";
    },
    indexMethod (index) {
      this.$emit("indexMethod", index);
    },
    cellClass () {
      return this.DisableSelection ? "DisableSelection" : "";
    },
    tableCellClassName ({ row, column, rowIndex, columnIndex }) {
      row.index = rowIndex;
      column.index = columnIndex;
      if (row.userIsNotarize === false) {
        return "myCell";
      }
      if (row.isLogout) {
        return "warning-row";
      }
      if (row.isBlackList) {
        return "blackList-row";
      }
      // 禁止选中的行添加样式
      if (!this.isRowCanBeSelect(row)) {
        return "disabled-row";
      }
      return "";
    },
    dbclick (row, column) {
      // 禁止行不触发双击编辑
      if (!this.isRowCanBeSelect(row)) return;

      this.inded = row.index;
      this.currentCell = `${row.index},${column.index}`;
      setTimeout(() => {
        const inputRef = this.$refs[`${row.index},${column.index}`];
        inputRef?.[0]?.focus();
      }, 0);
      this.$emit("dbclick", row);
    },
    inputChange (value, field, row) {
      this.$emit("inputChange", value, field, row);
      this.currentCell = null;
    },
    selectChange (value, arr, field, row, custom) {
      let emitValue = value;
      if (!custom) {
        const rule = arr.find((item) => item.customerName === value);
        emitValue = rule?.id || value;
      }
      this.$emit("selectChange", emitValue, field, row);
      this.currentCell = null;
    },
    selectDate (value, field, row) {
      this.$emit("selectDate", value, field, row);
      this.currentCell = null;
    },
    sortChange (column) {
      this.$emit("sortChange", column);
    },
    tableRowClassName ({ row, rowIndex }) {
      row.row_index = rowIndex;
      if (row.isStop) {
        return "warning-row";
      }
      // 禁止选中行的样式
      if (!this.isRowCanBeSelect(row)) {
        return "disabled-row";
      }
      // 选中行样式
      if (this.isRowSelected(row)) {
        return "success-row";
      }
      return "";
    },
  },
  watch: {
    // 数据更新后恢复选中状态（跳过禁止行）
    tableData: {
      immediate: true,
      handler () {
        this.$nextTick(() => {
          const table = this.$refs.table;
          if (!table || !this.selectedRowKeys.length) return;
          this.tableData.forEach(row => {
            if (this.isRowCanBeSelect(row) && this.selectedRowKeys.includes(row[this.rowKey])) {
              table.toggleRowSelection(row, true);
            }
          });
        });
      },
    },
  },
};
</script>
<style lang="less">
.TalentPool .blackList-row {
  font-style: italic;
  color: #909399;
}
#table {
  .el-table__footer-wrapper {
    .el-table__cell {
      border-right: 0 !important;
      background-color: rgb(245, 247, 250);
    }
  }

  //表格停用后的样式
  .el-table .warning-row {
    font-style: italic;
    color: rgba(128, 128, 128, 0.582);
  }
  // 加入黑名单后的样式

  //输入框的宽度
  .el-date-editor.el-input,
  .el-date-editor.el-input__inner {
    width: 100% !important;
  }

  //多选选中的样式
  .success-row td {
    background-color: #afcef3ab !important;
  }

  //表格按钮的样式
  .el-button--small {
    padding: 5px 15px;
  }
}

/* 用来设置当前页面element全局table 鼠标单击时的背景色*/
.el-table__body tr.current-row > td {
  background-color: #afcef3ab !important;
  /* color: #f19944; */
  /* 设置文字颜色，可以选择不设置 */
}
/* 用来设置当前页面element全局table 鼠标单击时的背景色*/
.el-table__body tr.hover-row > td {
  background-color: rgb(240, 199, 138) !important;
}
/* 用来设置当前页面element全局table 鼠标移入某行时的背景色*/
.el-table--enable-row-hover .el-table__body tr:hover > td {
  background-color: rgb(240, 199, 138) !important;
}

// #patorlWorkOrderTable{
//   border: 1px solid #acb3b9;
//   border-radius: 4px;
//   .el-table--border, .el-table--group{
//     border: none;
//   }
//   .tableList.el-table--border:after,.tableList.el-table--group:after,.tableList.el-table:before{
//     background-color: #acb3b9;
//     z-index: 5;
//   }
// }

// 线的位置和颜色以及宽度的调整
.countClass,
.countClassCell {
  position: relative;

  :first-child::after {
    content: "";
    left: -10px;
    bottom: 33px;
    width: 200%;
    height: 1px;
    position: absolute;
    background-color: #ebeef5;
  }
}
.el-table .DisableSelection .cell .el-checkbox__inner {
  display: none;
}
.count_row {
  height: 69px;
}

//  平均值顶部的线的调整
/deep/.el-table__footer-wrapper {
  border-top: 1px solid #ebeef5;

  tbody td {
    background-color: transparent;
  }
}

/deep/.el-table__fixed-footer-wrapper tbody td {
  background-color: transparent;
}
</style>